module.exports = __webpack_public_path__ + "img/make_mobile_03.367379d6.png";